import { extractErrorMessage } from 'app/providers/with-wagmi-auth/utils';
import { isAxiosError } from 'axios';
import { PaymentStatus } from 'entities/payment/model/payment.types';
import { selectCurrentTokenId, selectPaymentAssets } from 'entities/payment/model/selectors';
import { createAppAsyncThunk, logger, PayloadRejectMessage } from 'shared';

import { requestPayment } from '../../api';
import { actionTypes } from '../action-types';
import { actions } from '../reducer';

type ThunkData = {
  paymentTokenSymbol: string;
  network: string;
  packageName: string;
  paymentType: string;
  referralCode?: string;
};

export const confirmPayment = createAppAsyncThunk<null, ThunkData, { rejectValue: PayloadRejectMessage }>(
  actionTypes.CONFIRM_PAYMENT,
  async (data, { getState, dispatch }) => {
    try {
      const { data: paymentData } = await requestPayment({ ...data, packageName: data.packageName.toUpperCase() });

      const { tokens } = selectPaymentAssets(getState());
      const tokenId = selectCurrentTokenId(getState());

      if (!tokenId) return null;

      dispatch(
        actions.setPayment({
          status: PaymentStatus.WAITING_FOR_PAYMENT,
          payload: {
            ...paymentData,
            currencyAddress: tokens.byId[tokenId].address,
          },
        }),
      );

      return null;
    } catch (error) {
      logger(actionTypes.CONFIRM_PAYMENT, error);

      throw new Error(extractErrorMessage(error));
    }
  },
);
